/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LeadPreview from 'DesignSystem/LeadPreview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Content/Leads/Similar/Details/Content",
  handleClose
  
}) {
let similarLeadIdValueData = fromData.useDataValue({ viewPath,
context: 'similar_lead',
path: 'id',
})
  return (<React.Fragment
>
<LeadPreview
  viewPath={`${viewPath}/LeadPreview`}
 data="similar_lead.id"
 leadId={similarLeadIdValueData}
 showNextActions={false}
 handleClose={handleClose}
 hideActions={true}
/>
{children}
</React.Fragment>)
}